export default __webpack_public_path__ + "static/media/CoverImg.b8289edf.jpeg";